"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var animation_context_1 = require("./animation-context");

function useAnim(config, updateFunc) {
  // Auto start animation if no other options override this
  var shouldStart = true;
  var animationContext = react_1.useContext(animation_context_1.AnimationContext);

  if (animationContext && animationContext.started != undefined) {
    shouldStart = animationContext.started;
  }

  if (config.started != undefined) {
    shouldStart = config.started;
  }

  var _a = react_1.useState(shouldStart),
      startedAnimation = _a[0],
      setStartedAnimation = _a[1];

  if (!startedAnimation && shouldStart) {
    setStartedAnimation(true);
  }

  react_1.useEffect(exports.__createUseAnimEffect(startedAnimation, animationContext, config, updateFunc), [startedAnimation]);
  return {
    startedAnimation: startedAnimation
  };
}

exports.useAnim = useAnim; // This function is only exported, such that it can be used in tests.

exports.__createUseAnimEffect = function (startedAnimation, animationContext, config, updateFunc) {
  return function () {
    if (!startedAnimation) {
      return;
    }

    var currentFrame = undefined;
    var delay = 0;

    if (animationContext) {
      delay = animationContext.getStagger();
      animationContext.increaseStagger();
    }

    setTimeout(function () {
      var startTime = Date.now();
      var reverse = config.playMode === 'reverse';

      var update = function update() {
        var elapsed = Date.now() - startTime;
        var t = Math.min(1, elapsed / config.duration);

        if (reverse) {
          t = 1 - t;
        }

        if (config.easing) {
          if (reverse) {
            t = 1 - config.easing(1 - t);
          } else {
            t = config.easing(t);
          }
        }

        updateFunc(t);

        if (elapsed < config.duration) {
          currentFrame = requestAnimationFrame(update);
        } else if (config.playMode === 'loop' || config.playMode === 'pingPong') {
          startTime = Date.now();

          if (config.playMode === 'pingPong') {
            reverse = !reverse;
          }

          currentFrame = requestAnimationFrame(update);
        }
      };

      currentFrame = requestAnimationFrame(update);
    }, delay);
    return function () {
      if (currentFrame != undefined) {
        cancelAnimationFrame(currentFrame);
      }
    };
  };
};